import { eraseCookie } from "@/tools/cookie";
import type { MiddlewareContext } from "@/router";

export default async function auth({
  next,
  nextMiddleware,
}: MiddlewareContext) {
  const { useUser } = await import("@/stores/user/user");
  const { usePartner } = await import("@/stores/partner/partner");

  const userStore = useUser();
  const partnerStore = usePartner();

  if (!userStore.userIsLoggined) {
    await userStore.refreshAuth();
    await partnerStore.getPartner();
    if (!userStore.userIsLoggined) {
      eraseCookie("guestToken");
      eraseCookie("accessToken");
      eraseCookie("refreshToken");
      userStore.globalReset();
      return next({
        // name: "login",
        name: "enter",
      });
    }
  }

  if (nextMiddleware) {
    return nextMiddleware();
  }
}
